module.exports = __webpack_public_path__ + "img/breadcrumb-arrow.95669f6c.svg";